//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from "@angular/common/http";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import { Observable, throwError as _observableThrow, of as _observableOf } from "rxjs";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from "rxjs/operators";

export const DIRECTORY_API_BASE_URL = new InjectionToken<string>("DIRECTORY_API_BASE_URL");

@Injectable({
    providedIn: "root"
})
export class DirectoryClientV2 {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(DIRECTORY_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param source rce (Entry information came from the Rce Directory)

    ceq (Entry information came from the Carequality Directory)

    kno2 (Entry information came from the Kno2 System)

    nppes (Entry information came from the NPPES Directory)

    local (Entry information came from a local source such as user or organization)
     * @return OK
     */
    latest(source: DirectoryEntrySource): Observable<ImportHistoryDocument> {
        let url_ = this.baseUrl + "/Imports/{source}/latest";
        if (source === undefined || source === null) throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processLatest(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processLatest(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<ImportHistoryDocument>;
                        }
                    } else return _observableThrow(response_) as any as Observable<ImportHistoryDocument>;
                })
            );
    }

    protected processLatest(response: HttpResponseBase): Observable<ImportHistoryDocument> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ImportHistoryDocument);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * @param source rce (Entry information came from the Rce Directory)

    ceq (Entry information came from the Carequality Directory)

    kno2 (Entry information came from the Kno2 System)

    nppes (Entry information came from the NPPES Directory)

    local (Entry information came from a local source such as user or organization)
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    summarize(source: DirectoryEntrySource, startDate?: Date | undefined, endDate?: Date | undefined): Observable<SummarizeImportsResult[]> {
        let url_ = this.baseUrl + "/Imports/{source}/summarize?";
        if (source === undefined || source === null) throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (startDate === null) throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null) throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSummarize(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSummarize(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<SummarizeImportsResult[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<SummarizeImportsResult[]>;
                })
            );
    }

    protected processSummarize(response: HttpResponseBase): Observable<SummarizeImportsResult[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SummarizeImportsResult[]);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * @param source rce (Entry information came from the Rce Directory)

    ceq (Entry information came from the Carequality Directory)

    kno2 (Entry information came from the Kno2 System)

    nppes (Entry information came from the NPPES Directory)

    local (Entry information came from a local source such as user or organization)
     * @param body (optional) 
     * @return OK
     */
    start(source: DirectoryEntrySource, body?: StartImportJobApiRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Imports/{source}/start";
        if (source === undefined || source === null) throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json"
            })
        };

        return this.http
            .request("post", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processStart(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processStart(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processStart(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Removes a Purpose of Use code from the specified directory entry and cascades the removal
    to all descendant entries in the hierarchy. Returns 422 Validation Error if any entry
    (including descendants) would be left with zero Purpose of Use codes after removal.
     * @param id The root directory entry ID to remove the POU code from
     * @param pouCode The Purpose of Use code to remove
     * @return No Content
     */
    cascadeRemovePurposeOfUse(id: string, pouCode: string): Observable<void> {
        let url_ = this.baseUrl + "/{id}/purposes-of-use/{pouCode}";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pouCode === undefined || pouCode === null) throw new globalThis.Error("The parameter 'pouCode' must be defined.");
        url_ = url_.replace("{pouCode}", encodeURIComponent("" + pouCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http
            .request("delete", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCascadeRemovePurposeOfUse(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCascadeRemovePurposeOfUse(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processCascadeRemovePurposeOfUse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return _observableOf(null as any);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Previews the impact of removing a Purpose of Use code from the specified directory entry
    and all of its descendants. Returns the count of affected entries and identifies any
    "at-risk" entries that would be left with zero Purpose of Use codes after removal.
     * @param id The directory entry ID to preview removal for
     * @param pouCode The Purpose of Use code to preview removing
     * @return OK
     */
    previewPurposeOfUseRemoval(id: string, pouCode: string): Observable<PurposeOfUseRemovalPreviewResult> {
        let url_ = this.baseUrl + "/{id}/purposes-of-use/{pouCode}/removal-preview";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pouCode === undefined || pouCode === null) throw new globalThis.Error("The parameter 'pouCode' must be defined.");
        url_ = url_.replace("{pouCode}", encodeURIComponent("" + pouCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processPreviewPurposeOfUseRemoval(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processPreviewPurposeOfUseRemoval(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<PurposeOfUseRemovalPreviewResult>;
                        }
                    } else return _observableThrow(response_) as any as Observable<PurposeOfUseRemovalPreviewResult>;
                })
            );
    }

    protected processPreviewPurposeOfUseRemoval(response: HttpResponseBase): Observable<PurposeOfUseRemovalPreviewResult> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PurposeOfUseRemovalPreviewResult);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * @param _active (optional)
     * @return OK
     */
    getDirectoryEntriesDelegates(id: string, _active?: boolean | undefined): Observable<DirectoryEntrySummaryResult[]> {
        let url_ = this.baseUrl + "/{id}/delegates?";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (_active === null) throw new globalThis.Error("The parameter '_active' cannot be null.");
        else if (_active !== undefined) url_ += "_active=" + encodeURIComponent("" + _active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDirectoryEntriesDelegates(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDirectoryEntriesDelegates(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DirectoryEntrySummaryResult[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DirectoryEntrySummaryResult[]>;
                })
            );
    }

    protected processGetDirectoryEntriesDelegates(response: HttpResponseBase): Observable<DirectoryEntrySummaryResult[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DirectoryEntrySummaryResult[]);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDirectoryEntriesDelegators(id: string): Observable<DirectoryEntrySummaryResult[]> {
        let url_ = this.baseUrl + "/{id}/delegators";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDirectoryEntriesDelegators(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDirectoryEntriesDelegators(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DirectoryEntrySummaryResult[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DirectoryEntrySummaryResult[]>;
                })
            );
    }

    protected processGetDirectoryEntriesDelegators(response: HttpResponseBase): Observable<DirectoryEntrySummaryResult[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DirectoryEntrySummaryResult[]);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all ZIP codes in the same Health Referral Region (HRR) as the provided ZIP code.
    Uses the in-memory HRR seed data which includes Puerto Rico ZIP codes (HRR 900).
     * @param zipCode (optional) The ZIP code to look up
     * @return OK
     */
    getHrrZipCodes(zipCode?: string | undefined): Observable<GetHrrZipCodesResult> {
        let url_ = this.baseUrl + "/hrr/zip-codes?";
        if (zipCode === null) throw new globalThis.Error("The parameter 'zipCode' cannot be null.");
        else if (zipCode !== undefined) url_ += "zipCode=" + encodeURIComponent("" + zipCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetHrrZipCodes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetHrrZipCodes(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<GetHrrZipCodesResult>;
                        }
                    } else return _observableThrow(response_) as any as Observable<GetHrrZipCodesResult>;
                })
            );
    }

    protected processGetHrrZipCodes(response: HttpResponseBase): Observable<GetHrrZipCodesResult> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetHrrZipCodesResult);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the Directory Entry details based on the provided ID
     * @return OK
     */
    getDirectoryEntryDetail(id: string): Observable<DirectoryEntryDetail> {
        let url_ = this.baseUrl + "/{id}";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDirectoryEntryDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDirectoryEntryDetail(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DirectoryEntryDetail>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DirectoryEntryDetail>;
                })
            );
    }

    protected processGetDirectoryEntryDetail(response: HttpResponseBase): Observable<DirectoryEntryDetail> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DirectoryEntryDetail);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result404: any = null;
                    result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Not Found", status, _responseText, _headers, result404);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing Directory Entry based on the provided Kno2.Services.Directory.Models.UpdateDirectoryEntryRequest
     * @param body (optional)
     * @return Accepted
     */
    updateDirectoryEntry(id: string, body?: UpdateDirectoryEntryRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/{id}";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        };

        return this.http
            .request("put", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateDirectoryEntry(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateDirectoryEntry(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processUpdateDirectoryEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 202) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return _observableOf(null as any);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result404: any = null;
                    result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Not Found", status, _responseText, _headers, result404);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Queries Directory Entries based on the provided parameters with pagination support
     * @param orgId (optional) Filter by Kno2 organization ID
     * @param homeCommunityId (optional) Filter by home community ID
     * @param governance (optional) Filter by governance (defaults to 'Carequality')

    carequality

    tefca
     * @param name (optional) Filter by name (contains search)
     * @param directoryEntryType (optional) Filter by directory entry type

    qhin

    participant

    subparticipant

    implementer

    connection

    child
     * @param isParticipatingResponder (optional) Filter by responder status
     * @param state (optional) Filter by state (contains search)
     * @param lastUpdatedStart (optional) Filter by last updated time, greater than this date (UTC)
     * @param lastUpdatedEnd (optional) 
     * @param limit (optional) Number of items per page (default 500, max 500)
     * @param continuationToken (optional) Token for getting the next page of results
     * @param active (optional) Get active status of directory entries (null or unsent returns both active and inactive)
     * @return OK
     */
    getDirectoryEntries(
        orgId?: number | undefined,
        homeCommunityId?: string | undefined,
        governance?: Governance | undefined,
        name?: string | undefined,
        directoryEntryType?: DirectoryEntryType | undefined,
        isParticipatingResponder?: boolean | undefined,
        state?: string | undefined,
        lastUpdatedStart?: Date | undefined,
        lastUpdatedEnd?: Date | undefined,
        limit?: number | undefined,
        continuationToken?: string | undefined,
        active?: boolean | undefined
    ): Observable<DirectoryEntryDetailPaginatedResult> {
        let url_ = this.baseUrl + "/?";
        if (orgId === null) throw new globalThis.Error("The parameter 'orgId' cannot be null.");
        else if (orgId !== undefined) url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (homeCommunityId === null) throw new globalThis.Error("The parameter 'homeCommunityId' cannot be null.");
        else if (homeCommunityId !== undefined) url_ += "homeCommunityId=" + encodeURIComponent("" + homeCommunityId) + "&";
        if (governance === null) throw new globalThis.Error("The parameter 'governance' cannot be null.");
        else if (governance !== undefined) url_ += "governance=" + encodeURIComponent("" + governance) + "&";
        if (name === null) throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (directoryEntryType === null) throw new globalThis.Error("The parameter 'directoryEntryType' cannot be null.");
        else if (directoryEntryType !== undefined) url_ += "directoryEntryType=" + encodeURIComponent("" + directoryEntryType) + "&";
        if (isParticipatingResponder === null) throw new globalThis.Error("The parameter 'isParticipatingResponder' cannot be null.");
        else if (isParticipatingResponder !== undefined) url_ += "isParticipatingResponder=" + encodeURIComponent("" + isParticipatingResponder) + "&";
        if (state === null) throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined) url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (lastUpdatedStart === null) throw new globalThis.Error("The parameter 'lastUpdatedStart' cannot be null.");
        else if (lastUpdatedStart !== undefined)
            url_ += "lastUpdatedStart=" + encodeURIComponent(lastUpdatedStart ? "" + lastUpdatedStart.toISOString() : "") + "&";
        if (lastUpdatedEnd === null) throw new globalThis.Error("The parameter 'lastUpdatedEnd' cannot be null.");
        else if (lastUpdatedEnd !== undefined) url_ += "lastUpdatedEnd=" + encodeURIComponent(lastUpdatedEnd ? "" + lastUpdatedEnd.toISOString() : "") + "&";
        if (limit === null) throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (continuationToken === null) throw new globalThis.Error("The parameter 'continuationToken' cannot be null.");
        else if (continuationToken !== undefined) url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        if (active === null) throw new globalThis.Error("The parameter 'active' cannot be null.");
        else if (active !== undefined) url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDirectoryEntries(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDirectoryEntries(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DirectoryEntryDetailPaginatedResult>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DirectoryEntryDetailPaginatedResult>;
                })
            );
    }

    protected processGetDirectoryEntries(response: HttpResponseBase): Observable<DirectoryEntryDetailPaginatedResult> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DirectoryEntryDetailPaginatedResult);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Searches the directory for Directory Entries based on the provided parameters
     * @param _active (optional) When _active is false, results include both active and inactive directory entries
     * @param body (optional) Search request with filter criteria
     * @return OK
     */
    directoryEntrySearch(_active?: boolean | undefined, body?: DirectoryEntrySearchRequest | undefined): Observable<DirectoryEntryDetail[]> {
        let url_ = this.baseUrl + "/?";
        if (_active === null) throw new globalThis.Error("The parameter '_active' cannot be null.");
        else if (_active !== undefined) url_ += "_active=" + encodeURIComponent("" + _active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json"
            })
        };

        return this.http
            .request("post", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDirectoryEntrySearch(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDirectoryEntrySearch(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DirectoryEntryDetail[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DirectoryEntryDetail[]>;
                })
            );
    }

    protected processDirectoryEntrySearch(response: HttpResponseBase): Observable<DirectoryEntryDetail[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DirectoryEntryDetail[]);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * @param forcePublish (optional)
     * @return No Content
     */
    republish(directoryEntryId: string, forcePublish?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/{directoryEntryId}/republish?";
        if (directoryEntryId === undefined || directoryEntryId === null) throw new globalThis.Error("The parameter 'directoryEntryId' must be defined.");
        url_ = url_.replace("{directoryEntryId}", encodeURIComponent("" + directoryEntryId));
        if (forcePublish === null) throw new globalThis.Error("The parameter 'forcePublish' cannot be null.");
        else if (forcePublish !== undefined) url_ += "forcePublish=" + encodeURIComponent("" + forcePublish) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http
            .request("post", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processRepublish(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processRepublish(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processRepublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return _observableOf(null as any);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new Directory Entry based on the provided Kno2.Services.Directory.Models.CreateDirectoryEntryRequest
     * @param body (optional) Full Directory Entry Request
     * @return Created
     */
    createDirectoryEntry(body?: CreateDirectoryEntryRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        };

        return this.http
            .request("post", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateDirectoryEntry(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateDirectoryEntry(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processCreateDirectoryEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 201) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return _observableOf(null as any);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Generates the next available OID for the provided Kno2 Organization
     * @param body (optional)
     * @return OK
     */
    generateOid(body?: GenerateAvailableOidCommand | undefined): Observable<string> {
        let url_ = this.baseUrl + "/generate-oid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json"
            })
        };

        return this.http
            .request("post", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGenerateOid(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGenerateOid(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<string>;
                        }
                    } else return _observableThrow(response_) as any as Observable<string>;
                })
            );
    }

    protected processGenerateOid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Searches the directory and returns full Directory Entry documents (includes all fields like rootId)
     * @param _active (optional) When _active is false, results include both active and inactive directory entries
     * @param body (optional) Search request with filter criteria
     * @return OK
     */
    directoryEntrySearchFull(_active?: boolean | undefined, body?: DirectoryEntrySearchRequest | undefined): Observable<DirectoryEntryQueryResult[]> {
        let url_ = this.baseUrl + "/search/full?";
        if (_active === null) throw new globalThis.Error("The parameter '_active' cannot be null.");
        else if (_active !== undefined) url_ += "_active=" + encodeURIComponent("" + _active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json"
            })
        };

        return this.http
            .request("post", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDirectoryEntrySearchFull(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDirectoryEntrySearchFull(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<DirectoryEntryQueryResult[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<DirectoryEntryQueryResult[]>;
                })
            );
    }

    protected processDirectoryEntrySearchFull(response: HttpResponseBase): Observable<DirectoryEntryQueryResult[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DirectoryEntryQueryResult[]);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Searches for endpoints based on the provided request criteria
     * @param body (optional) The endpoint search request
     * @return OK
     */
    endpoints(body?: GetEndpointsApiRequest | undefined): Observable<GetEndpointsApiResult> {
        let url_ = this.baseUrl + "/search/endpoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json"
            })
        };

        return this.http
            .request("post", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processEndpoints(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processEndpoints(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<GetEndpointsApiResult>;
                        }
                    } else return _observableThrow(response_) as any as Observable<GetEndpointsApiResult>;
                })
            );
    }

    protected processEndpoints(response: HttpResponseBase): Observable<GetEndpointsApiResult> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetEndpointsApiResult);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Resolves an endpoint internally and returns the authorization scheme and token to use when calling it.
    The endpoint credentials are resolved server-side and never supplied by the caller.
     * @param body (optional) The resolution criteria for the endpoint
     * @return OK
     */
    getEndpointToken(body?: GetEndpointTokenQuery | undefined): Observable<EndpointTokenResult> {
        let url_ = this.baseUrl + "/endpoint-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json"
            })
        };

        return this.http
            .request("post", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEndpointToken(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEndpointToken(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<EndpointTokenResult>;
                        }
                    } else return _observableThrow(response_) as any as Observable<EndpointTokenResult>;
                })
            );
    }

    protected processGetEndpointToken(response: HttpResponseBase): Observable<EndpointTokenResult> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EndpointTokenResult);
                    return _observableOf(result200);
                })
            );
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result400: any = null;
                    result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Bad Request", status, _responseText, _headers, result400);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result404: any = null;
                    result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Not Found", status, _responseText, _headers, result404);
                })
            );
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result422: any = null;
                    result422 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Unprocessable Content", status, _responseText, _headers, result422);
                })
            );
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result500: any = null;
                    result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Internal Server Error", status, _responseText, _headers, result500);
                })
            );
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result502: any = null;
                    result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Bad Gateway", status, _responseText, _headers, result502);
                })
            );
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result503: any = null;
                    result503 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Service Unavailable", status, _responseText, _headers, result503);
                })
            );
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result504: any = null;
                    result504 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Gateway Timeout", status, _responseText, _headers, result504);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing Directory Entry with endpoint information for one or more transactions supported by the Participant
     * @param body (optional)
     * @return Accepted
     */
    updateDirectoryEntryEndpoints(id: string, body?: EndpointCandidate[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/{id}/endpoints";
        if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        };

        return this.http
            .request("put", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateDirectoryEntryEndpoints(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateDirectoryEntryEndpoints(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processUpdateDirectoryEntryEndpoints(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 202) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return _observableOf(null as any);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result404: any = null;
                    result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
                    return throwException("Not Found", status, _responseText, _headers, result404);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a list of all Kno2.IHE.Utils.Models.PurposeOfUseMappings
     * @param governance (optional) carequality

    tefca
     * @return OK
     */
    purposesOfUse(governance?: Governance | undefined): Observable<PurposeOfUse[]> {
        let url_ = this.baseUrl + "/PurposesOfUse?";
        if (governance === null) throw new globalThis.Error("The parameter 'governance' cannot be null.");
        else if (governance !== undefined) url_ += "governance=" + encodeURIComponent("" + governance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processPurposesOfUse(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processPurposesOfUse(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<PurposeOfUse[]>;
                        }
                    } else return _observableThrow(response_) as any as Observable<PurposeOfUse[]>;
                })
            );
    }

    protected processPurposesOfUse(response: HttpResponseBase): Observable<PurposeOfUse[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PurposeOfUse[]);
                    return _observableOf(result200);
                })
            );
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("Unauthorized", status, _responseText, _headers);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    version(): Observable<void> {
        let url_ = this.baseUrl + "/Version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http
            .request("get", url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processVersion(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processVersion(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                })
            );
    }

    protected processVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return _observableOf(null as any);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf(null as any);
    }
}

export interface Address {
    /**

organizationLocation

other */
    addressType: AddressType;
    street1?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    country?: string | undefined;
}

/** organizationLocation other */
export enum AddressType {
    OrganizationLocation = "organizationLocation",
    Other = "other"
}

export interface AlternateOrganizationOid {
    oid?: string | undefined;
    isDefault?: boolean;
}

export interface AuthenticationDetails {
    url?: string | undefined;
    /**

basic

oAuth */
    type: AuthenticationType;
    clientSecret: string | undefined;
    clientId: string | undefined;
}

/** basic oAuth */
export enum AuthenticationType {
    Basic = "basic",
    OAuth = "oAuth"
}

export interface ContactCandidate {
    firstName?: string | undefined;
    lastName?: string | undefined;
    nameText?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    street1?: string | undefined;
    street2?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
}

/** organization person support */
export enum ContactType {
    Organization = "organization",
    Person = "person",
    Support = "support"
}

export interface CreateDirectoryEntryRequest {
    /** The unique identifier for the directory entry, this will be combined with source and  saved as the id in the database and is expected to be in format:
```{source}:{identifier}``` */
    id?: string | undefined;
    /** The name of the organization or person the entry represents */
    name: string;
    /** Street address */
    street1?: string | undefined;
    street2?: string | undefined;
    /** City */
    city?: string | undefined;
    /** State */
    state?: string | undefined;
    /** Postal code or Zip Code */
    zipCode?: string | undefined;
    country?: string | undefined;
    /** The source responsible of the directory entry

rce (Entry information came from the Rce Directory)

ceq (Entry information came from the Carequality Directory)

kno2 (Entry information came from the Kno2 System)

nppes (Entry information came from the NPPES Directory)

local (Entry information came from a local source such as user or organization) */
    source: DirectoryEntrySource;
    homeCommunityId?: string | undefined;
    /** XCDR Message Delivery Address */
    inboundMessageAddress?: string | undefined;
    /** The governing body for the exchange participant using the directory entry

carequality

tefca */
    governance: Governance;
    /** Initiator Purpose of Use Codes */
    purposesOfUse?: string[] | undefined;
    /** If this organization is part of or a child to another directory entry, what is the ID of the parent */
    parentId?: string | undefined;
    /** Note these values map from:
<see href="https://sequoiaproject.org/SequoiaProjectHealthcareDirectoryImplementationGuide/output/ValueSet-OrganizationType.html" />

qhin

participant

subparticipant

implementer

connection

child */
    type: DirectoryEntryType;
    /** Describes the "responder type" for the directory entry.

noNode

respondingNode

passthroughNode */
    queryResponderType?: QueryResponderType | undefined;
    /**

directResponder

gatewayResponder

gatewayMember

childLocation

passThrough

initiatorOnly */
    responderType?: ResponderType | undefined;
    contacts?: ContactCandidate[] | undefined;
    /** Organization Id as defined by the Kno2 system. This is not the same as the HCID or other organization identifiers */
    kno2OrganizationId?: number | undefined;
    /**

prov

ems

obo

other

delegate */
    initiatorOnlyType?: InitiatorOnlyType | undefined;
    /** Whether or not this directory entry will be published for external consumption (e.g. to the RCE Directory). Defaults to false. */
    shouldNotPublish?: boolean;
    /** List of downstream delegates */
    delegates?: string[] | undefined;
    /**

hrr (HRR)

none (None)

preCheck (Pre Check) */
    responderFilter?: ResponderFilter | undefined;
    alternateOrganizationOids?: AlternateOrganizationOid[] | undefined;
    tefcaId?: string | undefined;
    npi?: string | undefined;
    /** Federal Employer Identification Number, nine digits with no separator. Optional. */
    fein?: string | undefined;
    isPayer?: boolean | undefined;
    naic?: string | undefined;
    /**

noNode

passthroughNode

initiatingNode */
    queryInitiatorType?: QueryInitiatorType | undefined;
    organizationNodeType?: string | undefined;
    managedBy?: ManagedByEntry | undefined;
}

export interface DirectoryContact {
    /**

organization

person

support */
    contactType?: ContactType;
    displayName?: string | undefined;
    legalname?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    title?: string | undefined;
    /**

individual

organization */
    npiType?: NpiType | undefined;
    /** An NPI is a 10-digit numeric identifier that is assigned to health care providers in the United States by the Centers for Medicare and Medicaid Services
(CMS). */
    npi?: string | undefined;
    addresses?: Address[] | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface DirectoryEntryDetail {
    orgId: string | undefined;
    displayName: string | undefined;
    homeCommunityId?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    parentOrgId?: string | undefined;
    legalName?: string | undefined;
    otherNames?: string[] | undefined;
    hasEndpoints?: boolean | undefined;
    xcpdEndpoint?: string | undefined;
    /**

rce (Entry information came from the Rce Directory)

ceq (Entry information came from the Carequality Directory)

kno2 (Entry information came from the Kno2 System)

nppes (Entry information came from the NPPES Directory)

local (Entry information came from a local source such as user or organization) */
    source: DirectoryEntrySource;
    npi?: string | undefined;
    isPayer?: boolean;
    naic?: string | undefined;
    readonly qualifiedAddress?: string | undefined;
    /**

carequality

tefca */
    governance?: Governance;
    /** Note these values map from:
<see href="https://sequoiaproject.org/SequoiaProjectHealthcareDirectoryImplementationGuide/output/ValueSet-OrganizationType.html" />

qhin

participant

subparticipant

implementer

connection

child */
    directoryEntryType?: DirectoryEntryType;
    created?: Date | undefined;
    delegates: string[] | undefined;
    initiatorPurposeOfUseCodes?: string[] | undefined;
    active?: boolean;
    lastUpdated?: Date;
    validForUseAfter?: Date | undefined;
    managedBy?: ManagedByEntry | undefined;
}

export interface DirectoryEntryDetailPaginatedResult {
    /** Collection of items returned in the current page */
    items?: DirectoryEntryDetail[] | undefined;
    /** When provided this is the URL to the next page of results */
    nextPageUrl?: string | undefined;
    /** Indicates if there are more items available */
    readonly hasMoreItems?: boolean;
}

export interface DirectoryEntryEndpointFilter {
    /**

itI38

itI39

itI55

itI80

fhirrest

unknown */
    transactionTypeCode?: TransactionTypeCode | undefined;
    /**

internal

external */
    visibility?: EndpointVisibility | undefined;
}

export interface DirectoryEntryFilter {
    /**

hrr (HRR)

none (None)

preCheck (Pre Check) */
    responderFilter?: ResponderFilter | undefined;
    includeInactiveDirectoryEntries?: boolean;
    zipCodes?: string[] | undefined;
    directoryEntryIds?: string[] | undefined;
    homeCommunityIds?: string[] | undefined;
    retrieveAllResponders?: boolean;
    kno2ManagedOnly?: boolean;
}

export interface DirectoryEntryQueryResult {
    id: string | undefined;
    /**

carequality

tefca */
    governance: Governance;
    kno2OrganizationId?: number | undefined;
    name: string | undefined;
    parentId?: string | undefined;
    rootId?: string | undefined;
    /**

rce (Entry information came from the Rce Directory)

ceq (Entry information came from the Carequality Directory)

kno2 (Entry information came from the Kno2 System)

nppes (Entry information came from the NPPES Directory)

local (Entry information came from a local source such as user or organization) */
    source: DirectoryEntrySource;
    homeCommunityId?: string | undefined;
    /** Note these values map from:
<see href="https://sequoiaproject.org/SequoiaProjectHealthcareDirectoryImplementationGuide/output/ValueSet-OrganizationType.html" />

qhin

participant

subparticipant

implementer

connection

child */
    directoryEntryType?: DirectoryEntryType;
    /**

directResponder

gatewayResponder

gatewayMember

childLocation

passThrough

initiatorOnly */
    responderType?: ResponderType | undefined;
    /**

noNode

respondingNode

passthroughNode */
    queryResponderType?: QueryResponderType | undefined;
    gatewayResponderId?: string | undefined;
    isActive?: boolean;
    isKno2Managed?: boolean;
    isParticipatingResponder?: boolean;
    /**

prov

ems

obo

other

delegate */
    initiatorOnlyType?: InitiatorOnlyType | undefined;
    inboundMessageAddress?: string | undefined;
    created?: Date;
    lastUpdated?: Date;
    /**

hrr (HRR)

none (None)

preCheck (Pre Check) */
    responderFilter?: ResponderFilter | undefined;
    /**

noNode

passthroughNode

initiatingNode */
    organizationNodeType?: QueryInitiatorType | undefined;
    /**

noNode

passthroughNode

initiatingNode */
    queryInitiatorType?: QueryInitiatorType | undefined;
    contacts: DirectoryContact[] | undefined;
    endpoints: EndpointQueryResult[] | undefined;
    purposeOfUseCodes: string[] | undefined;
    alternateOrganizationOids?: AlternateOrganizationOid[] | undefined;
    hierarchicalParentIds?: string[] | undefined;
    delegates?: string[] | undefined;
    validForUseAfter?: Date | undefined;
    firstActivationDate?: Date | undefined;
    tefcaId?: string | undefined;
    npi?: string | undefined;
    fein?: string | undefined;
    isPayer?: boolean;
    naic?: string | undefined;
    managedBy?: ManagedByEntry | undefined;
}

export interface DirectoryEntrySearchRequest {
    homeCommunityIds?: string[] | undefined;
    homeCommunityId?: string | undefined;
    /**

carequality

tefca */
    governance?: Governance;
    orgId?: string | undefined;
    /** Backwards-compatible alias for Kno2.Services.Directory.Models.DirectoryEntrySearchRequest.OrgId. */
    organizationId?: string | undefined;
    kno2OrganizationId?: number | undefined;
    parentId?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    isHealthReferralRegionSearch?: boolean;
    /** Legacy CEQ alias for Kno2.Services.Directory.Models.DirectoryEntrySearchRequest.IsHealthReferralRegionSearch. */
    includeHrrResults?: boolean;
    /**

qhin

participant

subparticipant

implementer

connection

child */
    directoryEntryType?: DirectoryEntryType | undefined;
}

/** rce (Entry information came from the Rce Directory) ceq (Entry information came from the Carequality Directory) kno2 (Entry information came from the Kno2 System) nppes (Entry information came from the NPPES Directory) local (Entry information came from a local source such as user or organization) */
export enum DirectoryEntrySource {
    Rce = "rce",
    Ceq = "ceq",
    Kno2 = "kno2",
    Nppes = "nppes",
    Local = "local"
}

export interface DirectoryEntrySummaryResult {
    id?: string | undefined;
    /**

carequality

tefca */
    governance?: Governance;
    kno2OrganizationId?: number | undefined;
    name?: string | undefined;
    parentId?: string | undefined;
    /**

rce (Entry information came from the Rce Directory)

ceq (Entry information came from the Carequality Directory)

kno2 (Entry information came from the Kno2 System)

nppes (Entry information came from the NPPES Directory)

local (Entry information came from a local source such as user or organization) */
    source?: DirectoryEntrySource;
    homeCommunityId?: string | undefined;
    /** Note these values map from:
<see href="https://sequoiaproject.org/SequoiaProjectHealthcareDirectoryImplementationGuide/output/ValueSet-OrganizationType.html" />

qhin

participant

subparticipant

implementer

connection

child */
    directoryEntryType?: DirectoryEntryType;
    isActive?: boolean;
    isParticipatingResponder?: boolean;
    delegates?: string[] | undefined;
    created?: Date;
    lastUpdated?: Date;
    rootId?: string | undefined;
    tefcaId?: string | undefined;
}

/** Note these values map from: <see href="https://sequoiaproject.org/SequoiaProjectHealthcareDirectoryImplementationGuide/output/ValueSet-OrganizationType.html" /> qhin participant subparticipant implementer connection child */
export enum DirectoryEntryType {
    Qhin = "qhin",
    Participant = "participant",
    Subparticipant = "subparticipant",
    Implementer = "implementer",
    Connection = "connection",
    Child = "child"
}

export interface EndpointCandidate {
    id?: string | undefined;
    value?: string | undefined;
    name?: string | undefined;
    httpMethod?: string | undefined;
    isActive?: boolean;
    audience?: string | undefined;
    scope?: string | undefined;
    isInternal?: boolean | undefined;
    authenticationDetails?: AuthenticationDetails | undefined;
    /**

itI38

itI39

itI55

itI80

fhirrest

unknown */
    transactionType: TransactionTypeCode;
    /** value which is a globally unique identifier for a community and is used to obtain the Web Services endpoint of services that provide access to data in that
community. Specifically:
<ul><li>
        It is returned within the response to Cross Gateway Query and Registry Stored Query transactions to indicate the association of a response element
        with a community. Document Consumers process the value in the response as an opaque unique identifier.
    </li><li>
        It is an optional parameter to Registry Stored Query requests, not requiring a patient id parameter, and Retrieve Document Set requests to indicate
        which community to direct the request.
    </li><li>It is used by Initiating Gateways to direct requests to the community where the initial data originated.</li></ul> */
    homeCommunityId?: string | undefined;
    assigningAuthorityId?: string | undefined;
    /** Responder endpoint Purpose of Use Codes */
    purposesOfUse?: string[] | undefined;
    /**

rce (Entry information came from the Rce Directory)

ceq (Entry information came from the Carequality Directory)

kno2 (Entry information came from the Kno2 System)

nppes (Entry information came from the NPPES Directory)

local (Entry information came from a local source such as user or organization) */
    source: DirectoryEntrySource;
    /**

respondingNode

passthroughNode */
    endpointType?: EndpointType | undefined;
    /**

kno2StandardApi

fhirQueryBasedDocumentExchange */
    responderImplementationType?: ResponderImplementationType;
}

export interface EndpointQueryResult {
    name: string | undefined;
    address: string | undefined;
    httpMethod?: string | undefined;
    authenticationDetails?: AuthenticationDetails | undefined;
    /**

itI38

itI39

itI55

itI80

fhirrest

unknown */
    transactionType: TransactionTypeCode;
    /**

kno2StandardApi

fhirQueryBasedDocumentExchange */
    responderImplementationType?: ResponderImplementationType | undefined;
    homeCommunityId: string | undefined;
    assigningAuthorityId?: string | undefined;
    isActive?: boolean;
    scope?: string | undefined;
    audience?: string | undefined;
    isInternal?: boolean;
    purposeOfUseCodes?: string[] | undefined;
}

export interface EndpointTokenResult {
    scheme?: string | undefined;
    token?: string | undefined;
}

/** respondingNode passthroughNode */
export enum EndpointType {
    RespondingNode = "respondingNode",
    PassthroughNode = "passthroughNode"
}

/** internal external */
export enum EndpointVisibility {
    Internal = "internal",
    External = "external"
}

export interface GenerateAvailableOidCommand {
    kno2OrganizationId: number;
    source: string | undefined;
}

export interface GetEndpointTokenQuery {
    directoryEntryId: string | undefined;
    /**

carequality

tefca */
    governance: Governance;
    /**

itI38

itI39

itI55

itI80

fhirrest

unknown */
    transactionTypeCode: TransactionTypeCode;
    /**

internal

external */
    visibility: EndpointVisibility;
}

export interface GetEndpointsApiRequest {
    requester?: RequesterInformation | undefined;
    /**

carequality

tefca */
    governance?: Governance;
    directoryEntryFilter?: DirectoryEntryFilter | undefined;
    directoryEntryEndpointFilter?: DirectoryEntryEndpointFilter | undefined;
}

export interface GetEndpointsApiResult {
    requester?: DirectoryEntryQueryResult | undefined;
    targets?: DirectoryEntryQueryResult[] | undefined;
}

export interface GetHrrZipCodesResult {
    hrrNumber?: string | undefined;
    zipCodes?: string[] | undefined;
}

/** carequality tefca */
export enum Governance {
    Carequality = "carequality",
    Tefca = "tefca"
}

export interface ImportHistoryDocument {
    id?: string | undefined;
    jobId: string | undefined;
    /**

rce (Entry information came from the Rce Directory)

ceq (Entry information came from the Carequality Directory)

kno2 (Entry information came from the Kno2 System)

nppes (Entry information came from the NPPES Directory)

local (Entry information came from a local source such as user or organization) */
    source: DirectoryEntrySource;
    predictedTotalImportCount?: number;
    cumulativeImportCount?: number;
    batchNumber?: number;
    startTimeUtc?: Date;
    endTimeUtc?: Date;
    lastSuccessfullyImportedDocumentDateTimeUtc?: Date;
    manuallyTriggered?: boolean;
    successfulEntries?: string[] | undefined;
    failedEntries?: string[] | undefined;
    readonly count?: number;
    readonly failureCount?: number;
    readonly successCount?: number;
    created?: Date;
}

/** prov ems obo other delegate */
export enum InitiatorOnlyType {
    Prov = "prov",
    Ems = "ems",
    Obo = "obo",
    Other = "other",
    Delegate = "delegate"
}

export interface ManagedByEntry {
    id: string | undefined;
    displayName: string | undefined;
    governance: string | undefined;
    readonly role?: string | undefined;
}

/** Health Care Provider NPI Categories individual organization */
export enum NpiType {
    Individual = "individual",
    Organization = "organization"
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface PurposeOfUse {
    code: string | undefined;
    description: string | undefined;
    /**

carequality

tefca */
    governance?: Governance;
}

export interface PurposeOfUseRemovalPreviewResult {
    affectedCount?: number;
    hasAtRiskDescendants?: boolean;
    atRiskDescendantNames?: string[] | undefined;
}

/** noNode passthroughNode initiatingNode */
export enum QueryInitiatorType {
    NoNode = "noNode",
    PassthroughNode = "passthroughNode",
    InitiatingNode = "initiatingNode"
}

/** noNode respondingNode passthroughNode */
export enum QueryResponderType {
    NoNode = "noNode",
    RespondingNode = "respondingNode",
    PassthroughNode = "passthroughNode"
}

export interface RequesterInformation {
    id?: string | undefined;
    kno2OrganizationId?: number | undefined;
    homeCommunityId?: string | undefined;
    authorizingDirectoryEntryId?: string | undefined;
    purposeOfUseCode?: string | undefined;
}

/** hrr (HRR) none (None) preCheck (Pre Check) */
export enum ResponderFilter {
    Hrr = "hrr",
    None = "none",
    PreCheck = "preCheck"
}

/** kno2StandardApi fhirQueryBasedDocumentExchange */
export enum ResponderImplementationType {
    Kno2StandardApi = "kno2StandardApi",
    FhirQueryBasedDocumentExchange = "fhirQueryBasedDocumentExchange"
}

/** directResponder gatewayResponder gatewayMember childLocation passThrough initiatorOnly */
export enum ResponderType {
    DirectResponder = "directResponder",
    GatewayResponder = "gatewayResponder",
    GatewayMember = "gatewayMember",
    ChildLocation = "childLocation",
    PassThrough = "passThrough",
    InitiatorOnly = "initiatorOnly"
}

export interface StartImportJobApiRequest {
    fullRefresh?: boolean | undefined;
    importStartDate?: Date | undefined;
    idsToImport?: string[] | undefined;
}

export interface SummarizeImportsResult {
    jobId?: string | undefined;
    manuallyTriggered?: boolean;
    startTimeUtc?: Date;
    endTimeUtc?: Date;
    lastImportedDocumentDateTimeUtc?: Date;
    batchCount?: number;
    totalImported?: number;
    successfulImports?: number;
    failedImports?: string[] | undefined;
}

/** itI38 itI39 itI55 itI80 fhirrest unknown */
export enum TransactionTypeCode {
    ItI38 = "itI38",
    ItI39 = "itI39",
    ItI55 = "itI55",
    ItI80 = "itI80",
    Fhirrest = "fhirrest",
    Unknown = "unknown"
}

export interface UpdateDirectoryEntryRequest {
    /** The unique identifier for the directory entry, this will be saved as the id in the database and is expected to be in format:
```{partitionKey}:{identifier}``` */
    id: string;
    /** The name of the organization or person the entry represents */
    name: string;
    /** Street address */
    street1?: string | undefined;
    street2?: string | undefined;
    /** City */
    city?: string | undefined;
    /** State */
    state?: string | undefined;
    /** Postal code or Zip Code */
    zipCode?: string | undefined;
    country?: string | undefined;
    /** Whether or not the directory entry is active */
    isActive?: boolean;
    /** What source did the directory entry come from

rce (Entry information came from the Rce Directory)

ceq (Entry information came from the Carequality Directory)

kno2 (Entry information came from the Kno2 System)

nppes (Entry information came from the NPPES Directory)

local (Entry information came from a local source such as user or organization) */
    source: DirectoryEntrySource;
    homeCommunityId?: string | undefined;
    /** XCDR Message Delivery Address */
    inboundMessageAddress?: string | undefined;
    /** The governance model for the directory entry

carequality

tefca */
    governance: Governance;
    /** Initiator Purpose of Use Codes */
    purposesOfUse?: string[] | undefined;
    /** List of downstream delegates */
    delegates?: string[] | undefined;
    /** If this organization is part of or a child to another directory entry, what is the ID of the parent */
    parentId?: string | undefined;
    /**

prov

ems

obo

other

delegate */
    initiatorOnlyType?: InitiatorOnlyType | undefined;
    /** Note these values map from:
<see href="https://sequoiaproject.org/SequoiaProjectHealthcareDirectoryImplementationGuide/output/ValueSet-OrganizationType.html" />

qhin

participant

subparticipant

implementer

connection

child */
    type: DirectoryEntryType;
    /** Describes the "type" for the directory entry.

noNode

respondingNode

passthroughNode */
    queryResponderType?: QueryResponderType | undefined;
    contacts?: ContactCandidate[] | undefined;
    /**

hrr (HRR)

none (None)

preCheck (Pre Check) */
    responderFilter?: ResponderFilter | undefined;
    kno2OrganizationId?: number | undefined;
    alternateOrganizationOids?: AlternateOrganizationOid[] | undefined;
    tefcaId?: string | undefined;
    npi?: string | undefined;
    fein?: string | undefined;
    isPayer?: boolean | undefined;
    naic?: string | undefined;
    /**

noNode

passthroughNode

initiatingNode */
    queryInitiatorType?: QueryInitiatorType | undefined;
    /**

directResponder

gatewayResponder

gatewayMember

childLocation

passThrough

initiatorOnly */
    responderType?: ResponderType | undefined;
    organizationNodeType?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): Observable<any> {
    if (result !== null && result !== undefined) return _observableThrow(result);
    else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = (event) => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
